import React from 'react';

import { Faq } from '@entities/faq';

const FaqPage = () => {
	return <Faq />;
};

export default FaqPage;
